import * as React from 'react';
import DialogBase from '../../Shared/DialogBase';
import ProjectUsers from './ProjectUsers';

export interface IProjectUsersDialogProps {
    projectId?: number;
    open: boolean;
    onClose: () => void;
}

export default function ProjectUsersDialog(props: IProjectUsersDialogProps) {
    return (
        <DialogBase minWidth={600} open={props.open} onClose={props.onClose} title='Uživatelé projektu'>
            <ProjectUsers projectId={props.projectId} />
        </DialogBase>
    );
}
